<script setup>
const props = defineProps({
  /* Defaults from your original design */

  h1Start: { type: String },
  h1Accent: { type: String },
  h2: { type: String },
  body: { type: String },
  cta1: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
  cta2: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
});
</script>

<template>
  <section
    class="relative overflow-hidden font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <div class="grid items-center gap-12 lg:grid-cols-2">
      <!-- Copy -->
      <div class="order-2 md:order-1 px-2 md:px-0">
        <h1
          class="text-balance uppercase text-2xl sm:text-5xl md:text-6xl font-extrabold font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
        >
          {{ h1Start }}
          <span
            class="inline-block bg-clip-text text-transparent bg-gradient-to-br from-iq-primary to-iq-secondary"
          >
            {{ h1Accent }}
          </span>
        </h1>

        <h2 class="mt-6 text-pretty text-lg sm:text-2xl text-iq-paragraph-color/90">
          {{ h2 }}
        </h2>

        <p class="mt-5 max-w-2xl leading-relaxed">
          {{ body }}
        </p>

        <div class="mt-8 flex flex-wrap items-center gap-3">
          <NuxtLink :to="cta1.path" class="group iq-cta">
            {{ cta1.label }}
            <Icon
              name="material-symbols:arrow-right"
              class="text-2xl transition-transform group-hover:translate-x-0.5"
            />
          </NuxtLink>

          <NuxtLink :to="cta2.path" class="iq-cta-secondary">
            {{ cta2.label }}
          </NuxtLink>
        </div>
      </div>

      <div class="order-1 md:order-2">
        <slot />
      </div>
    </div>
  </section>
</template>
